/* eslint-disable import/prefer-default-export */
import { object, string, array } from 'yup';

export const CustomFieldsSchema = object({
    name: string().required('Field name is required'),
    data_type: string().required('Input type is required'),
    category: string().required('Field location is required'),
    options: array()
        .of(
            object({
                value: string().required('Option value is required'),
            })
        )
        .when('data_type', {
            is: 'select',
            then: (schema) => schema.min(1, 'At least one option is required'),
            otherwise: (schema) => schema.optional(),
        }),
});
